module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.ttf";